<template>
    <div class="d-flex all-after-header-box">
        <!-- Левое меню модуля -->
        <div 
            :class="{'drawer-left-wrap' : true, 'dlw-large' : (!drawerLeftMenuMini), 'drawer-menu-hover': drawerLeftMenuHover }"
            @mouseenter="LeftMenuMouseenter()"
            @mouseleave="LeftMenuMouseleave()"
        >
            <v-navigation-drawer
                absolute
                permanent
                class="drawer-menu"
                v-model="drawerLeftMenu"
            >

                <template v-if="allowCreateProtocol">
                    <v-divider class="mr-2 ml-2"></v-divider>

                    <v-list
                        nav
                        dense
                        class="dm-actions-list"
                    >
                        <v-list-item-group
                            color="#009c95"
                        >
                            <v-list-item 
                                link
                                class="v-item--active v-list-item--active drawer-menu-list-bigbtn"
                                @click="onCreateClicked"
                            >
                                <v-list-item-icon>
                                    <v-icon>mdi-plus-box</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Добавить") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </template>

                <v-divider 
                    v-if="isDebug" 
                    class="mr-2 ml-2"></v-divider>

                <v-list 
                    v-if="isDebug"
                    nav dense shaped>
                    <v-list-item
                        link
                        key="MyOrdersDashboard"
                        :to="{ name: 'MyOrdersDashboard' }"
                    >

                        <v-list-item-icon>
                            <v-icon>far fa-chart-pie</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("Dashboard") }}</v-list-item-title>                       
                    </v-list-item>
                </v-list>

                <!--header-->
                <v-list class="dm-list-header" nav dense shaped>   
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('Мои_задания')}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list nav dense shaped>

                    <v-list-group 
                        v-model="myOrdersGroupActive.active"
                        :accordion="true"
                        @input="closeOtherGroups('myOrdersGroupActive')"
                    >
                        
                        <template v-slot:prependIcon>
                            <v-icon>far fa-wrench</v-icon>
                        </template>
                        <template v-slot:activator>
                            <v-list-item-title>
                                {{ $t("В_работе") }} 
                                <sup 
                                    v-if="hasInWorkUread" style="color:#F04747;"
                                >
                                    &#x23FA;
                                </sup>
                            </v-list-item-title>
                        </template>
                        <template v-slot:appendIcon>
                            <v-icon>fas fa-chevron-down</v-icon>
                        </template>

                        <!-- На_исполнении -->
                        <v-list-item
                            link
                            key="MyOrdersOnExecution"
                            :to="{ name: 'MyOrdersOnExecution' }"
                        >

                            <v-list-item-icon>
                                <v-icon></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Исполнить") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': myOrdersOnExecutionUnreadedCounter <= 0, 'dm-counter-red': myOrdersOnExecutionUnreadedCounter > 0 }">
                                <v-progress-circular v-if="isCountersLoading && (myOrdersOnExecutionUnreadedCounter + myOrdersOnExecutionCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                <template v-else-if="myOrdersOnExecutionUnreadedCounter > 0">
                                    +{{ myOrdersOnExecutionUnreadedCounter }}
                                </template>
                                <template v-else-if="myOrdersOnExecutionCounter > 0">
                                    {{ myOrdersOnExecutionCounter }}
                                </template>
                            </div>
                        </v-list-item>

                        <!-- На_согласовании -->
                        <v-list-item
                            link
                            key="MyProcessesOnAdjustment"
                            :to="{ name: 'MyProcessesOnAdjustment' }"
                        >

                            <v-list-item-icon>
                                <v-icon></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Согласовать") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': myProcessesOnAdjustmentUnreadedCounter <= 0, 'dm-counter-red': myProcessesOnAdjustmentUnreadedCounter > 0 }">
                                <v-progress-circular v-if="isCountersLoading && (myProcessesOnAdjustmentUnreadedCounter + myProcessesOnAdjustmentCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                <template v-else-if="myProcessesOnAdjustmentUnreadedCounter > 0">
                                    +{{ myProcessesOnAdjustmentUnreadedCounter }}
                                </template>
                                <template v-else-if="myProcessesOnAdjustmentCounter > 0">
                                    {{ myProcessesOnAdjustmentCounter }}
                                </template>
                            </div>
                        </v-list-item>

                        <!-- На_продлении -->
                        <v-list-item
                            link
                            key="MyProcessesOnProlongation"
                            :to="{ name: 'ProtocolOnProlongationList' }"
                        >

                            <v-list-item-icon>
                                <v-icon></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Продлить_срок") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': myProcessesOnProlongationUnreadCounter <= 0, 'dm-counter-red': myProcessesOnProlongationUnreadCounter > 0 }">
                                <v-progress-circular v-if="isCountersLoading && (myProcessesOnProlongationUnreadCounter + myProcessesOnProlongationCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                <template v-else-if="myProcessesOnProlongationUnreadCounter > 0">
                                    +{{ myProcessesOnProlongationUnreadCounter }}
                                </template>
                                <template v-else-if="myProcessesOnProlongationCounter > 0">
                                    {{ myProcessesOnProlongationCounter }}
                                </template>
                            </div>
                        </v-list-item>
                        
                        <!-- Для_снятия_с_контроля -->
                        <v-list-item
                            link
                            key="MyProcessesOnExecutionControl"
                            :to="{ name: 'ProtocolOnExecutionControlList' }"
                        >
                            <v-list-item-icon>
                            <v-icon></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('Снять_с_контроля') }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': myProcessesExecutionControlUnreadedCounter <= 0, 'dm-counter-red': myProcessesExecutionControlUnreadedCounter > 0 }">
                                <v-progress-circular v-if="isCountersLoading && (myProcessesExecutionControlUnreadedCounter + myProcessesExecutionControlCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                <template v-else-if="myProcessesExecutionControlUnreadedCounter > 0">
                                    +{{ myProcessesExecutionControlUnreadedCounter }}
                                </template>
                                <template v-else-if="myProcessesExecutionControlCounter > 0">
                                    {{ myProcessesExecutionControlCounter }}
                                </template>
                            </div>
                        </v-list-item>

                    </v-list-group>

                    <!-- Мой контроль -->
                    <v-list-group 
                        v-model="myOrdersOnControlGroupActive.active"
                        :accordion="true"
                        @input="closeOtherGroups('myOrdersOnControlGroupActive')"
                    >

                        <template v-slot:prependIcon>
                            <v-icon>far fa-calendar-circle-exclamation</v-icon>
                        </template>
                        <template v-slot:activator>
                            <v-list-item-title>
                                {{ $t("Мой_контроль") }}
                                <sup 
                                    v-if="hasInMyControlUread" style="color:#F04747;"
                                >
                                    &#x23FA;
                                </sup>
                            </v-list-item-title>
                        </template>
                        <template v-slot:appendIcon>
                            <v-icon>fas fa-chevron-down</v-icon>
                        </template>

                        <v-list-item
                            link
                            key="MyOrdersOnControl"
                            :to="{ name: 'MyOrdersOnControl' }"
                        >

                            <v-list-item-icon>
                                <v-icon></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Поручения") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': myControlUnreadedOrdersCounter <= 0, 'dm-counter-red': myControlUnreadedOrdersCounter > 0 }">
                                <v-progress-circular v-if="isCountersLoading && (myControlUnreadedOrdersCounter + myControlOrdersCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                <template v-else-if="myControlUnreadedOrdersCounter > 0">
                                    +{{ myControlUnreadedOrdersCounter }}
                                </template>
                                <template v-else-if="myControlOrdersCounter > 0">
                                    {{ myControlOrdersCounter }}
                                </template>
                            </div>
                        </v-list-item>

                        <v-list-item
                            link
                            key="MyTasksOnControl"
                            :to="{ name: 'MyTasksOnControl' }"
                        >

                            <v-list-item-icon>
                                <v-icon></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Задачи") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': myControlUnreadedTasksCounter <= 0, 'dm-counter-red': myControlUnreadedTasksCounter > 0 }">
                                <v-progress-circular v-if="isCountersLoading && (myControlUnreadedTasksCounter + myControlTasksCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                <template v-else-if="myControlUnreadedTasksCounter > 0">
                                    +{{ myControlUnreadedTasksCounter }}
                                </template>
                                <template v-else-if="myControlTasksCounter > 0">
                                    {{ myControlTasksCounter }}
                                </template>
                            </div>
                        </v-list-item>
                    </v-list-group>

                    <!-- Отправленные -->
                    <v-list-item
                        link
                        key="MyOrdersOnCheck"
                        :to="{ name: 'MyOrdersOnCheck' }"
                    >

                        <v-list-item-icon>
                            <v-icon>far fa-paper-plane</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("Отправленные") }}</v-list-item-title>
                        <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': myOrdersOnCheckUnreadedCounter <= 0, 'dm-counter-red': myOrdersOnCheckUnreadedCounter > 0 }">
                            <v-progress-circular v-if="isCountersLoading && (myOrdersOnCheckUnreadedCounter + myOrdersOnCheckCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                            <template v-else-if="myOrdersOnCheckUnreadedCounter > 0">
                                +{{ myOrdersOnCheckUnreadedCounter }}
                            </template>
                            <template v-else-if="myOrdersOnCheckCounter > 0">
                                {{ myOrdersOnCheckCounter }}
                            </template>
                        </div>
                    </v-list-item>

                </v-list>

                <!--header-->
                <v-list class="dm-list-header" nav dense shaped>   
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('Документы') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list
                    nav
                    dense
                    shaped
                >

                    <v-list-item
                        link
                        :to="{ name: 'Orders' }"
                    >
                        <v-list-item-icon>
                        <v-icon>far fa-clipboard-list</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("Протоколы") }}</v-list-item-title>
                        <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': protocolUnreadCounter <= 0, 'dm-counter-red': protocolUnreadCounter > 0 }">
                            <v-progress-circular v-if="isCountersLoading && (protocolCounter + protocolUnreadCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                            <template v-else-if="protocolUnreadCounter > 0">
                                +{{ protocolUnreadCounter }}
                            </template>
                            <template v-else-if="protocolCounter > 0">
                                {{ protocolCounter }}
                            </template>
                        </div>
                    </v-list-item>

                    <v-list-item
                        link
                        :to="{ name: 'ActItems', params: { type: 'inner' } }"
                    >
                        <v-list-item-icon>
                        <v-icon>far fa-inbox</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("Поручения") }}</v-list-item-title>
                        <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': innerOrdersUnreadCounter <= 0, 'dm-counter-red': innerOrdersUnreadCounter > 0 }">
                            <v-progress-circular v-if="isCountersLoading && (innerOrdersCounter + innerOrdersUnreadCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                            <template v-else-if="innerOrdersUnreadCounter > 0">
                                +{{ innerOrdersUnreadCounter }}
                            </template>
                            <template v-else-if="innerOrdersCounter > 0">
                                {{ innerOrdersCounter }}
                            </template>
                        </div>
                    </v-list-item>
                    <!--
                    <v-list-group 
                        v-model="assignmentsGroupActive.active"
                        :accordion="true"
                        @input="closeOtherGroups('assignmentsGroupActive')"
                    >
                        <template v-slot:prependIcon>
                            <v-icon>far fa-inbox</v-icon>
                        </template>
                        <template v-slot:activator>
                            <v-list-item-title>
                                {{ $t("Поручения") }}
                                <sup 
                                    v-if="hasInOrdersUnread" style="color:#F04747;"
                                >
                                    &#x23FA;
                                </sup>
                            </v-list-item-title>
                        </template>
                        <template v-slot:appendIcon>
                            <v-icon>fas fa-chevron-down</v-icon>
                        </template>

                        <v-list-item
                            link
                            :to="{ name: 'ActItems', params: { type: 'inner' } }"
                        >
                            <v-list-item-icon>
                            <v-icon></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Внутренние") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': innerOrdersUnreadCounter <= 0, 'dm-counter-red': innerOrdersUnreadCounter > 0 }">
                                <v-progress-circular v-if="isCountersLoading && (innerOrdersCounter + innerOrdersUnreadCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                <template v-else-if="innerOrdersUnreadCounter > 0">
                                    +{{ innerOrdersUnreadCounter }}
                                </template>
                                <template v-else-if="innerOrdersCounter > 0">
                                    {{ innerOrdersCounter }}
                                </template>
                            </div>
                        </v-list-item>

                        <v-list-item
                            link
                            :to="{ name: 'ActItems', params: { type: 'outer' } }"
                        >
                            <v-list-item-icon>
                            <v-icon></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Внешние") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': outerOrdersUnreadCounter <= 0, 'dm-counter-red': outerOrdersUnreadCounter > 0 }">
                                <v-progress-circular v-if="isCountersLoading && (outerOrdersCounter + outerOrdersUnreadCounter) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                <template v-else-if="outerOrdersUnreadCounter > 0">
                                    +{{ outerOrdersUnreadCounter }}
                                </template>
                                <template v-else-if="outerOrdersCounter > 0">
                                    {{ outerOrdersCounter }}
                                </template>
                            </div>
                        </v-list-item>
                    </v-list-group>
                    
                    <v-list-item
                        link
                        :to="{ name: 'ProtocolsRemovedFromControl' }"
                    >
                        <v-list-item-icon>
                            <v-icon>fa-regular fa-calendar-check</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("Снятые_с_контроля") }}</v-list-item-title>
                    </v-list-item>
                    -->
                    <v-list-item
                        link
                        :to="{ name: 'ActItemsFavorites', params: { type: 'favorites' }}"
                    >
                        <v-list-item-icon>
                        <v-icon>far fa-star</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("Избранные") }}</v-list-item-title>
                    </v-list-item>

                </v-list>               

                <template v-if="allowSwetofor">
                    <!--header-->
                    <v-list class="dm-list-header" nav dense shaped>   
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ $t('Контроль') }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-list
                        nav
                        dense
                        shaped
                    >
                        <v-list-item
                            link
                            :to="{ name: 'Reporting' }"
                        >
                            <v-list-item-icon>
                                <v-icon>far fa-chart-line</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Отчетность") }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            link
                            :to="{ name: 'ProtocolsSvetofor' }"
                        >
                            <v-list-item-icon>
                                <v-icon>far fa-traffic-light-go</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Светофор") }}</v-list-item-title>
                        </v-list-item>
                        
                        <v-list-group
                            v-model="svetoforGroupActive.active"
                            :accordion="true"
                            @input="closeOtherGroups('svetoforGroupActive')"
                        >
                            <template v-slot:prependIcon>
                                <v-icon>fa-regular fa-calendar-range</v-icon>
                            </template>
                            <template v-slot:activator>
                                <v-list-item-title>{{ $t("Исполнительская_дисциплина") }}</v-list-item-title>
                            </template>
                            <template v-slot:appendIcon>
                                <v-icon>fas fa-chevron-down</v-icon>
                            </template>
                        
                            <v-list-item
                                link
                                :to="{ name: 'ProtocolsByCurrentPeriod' }"
                            >
                                <v-list-item-icon>
                                    <v-icon></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Поручения_в_работе") }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                link
                                :to="{ name: 'ProtocolsByPastPeriods' }"
                            >
                                <v-list-item-icon>
                                    <v-icon></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Просроченные_поручения") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-group>

                        <v-list-item
                            link
                            :to="{ name: 'ProtocolsCompleted' }"
                        >
                            <v-list-item-icon>
                                <v-icon>fa-regular fa-calendar-arrow-down</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Выполненные") }}</v-list-item-title>
                        </v-list-item>

                        
                        
                    </v-list>
                </template>

                <template>
                    <v-list class="dm-list-header" nav dense shaped>   
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ $t('Архивные_поручения') }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-list
                        nav
                        dense
                        shaped
                    >
                        <v-list-item
                            link
                            :to="{ name: 'ProtocolsRemovedFromControl', params: { type: 'inner' } }"
                        >
                            <v-list-item-icon>
                                <v-icon>fa-regular fa-calendar-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Внутренние_поручения") }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            link
                            :to="{ name: 'ProtocolsRemovedFromControl', params: { type: 'outer' } }"
                        >
                            <v-list-item-icon>
                                <v-icon>fa-regular fa-calendar-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Внешние_поручения") }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </template>
            </v-navigation-drawer>
        </div>

        <div class="content-box">

            <router-view :key="$route.fullPath" />
            
        </div>

        <CreateDialog ref="CreateDlg" />

    </div>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
import { mapGetters, mapActions } from 'vuex';
import CreateDialog from '@/components/orders/dialogs/CreateDlg.vue';
export default {
    name: "Orders",
    components: {
        CreateDialog
    },
    computed: {
        ...mapGetters({ drawerLeftMenuMini: 'isDrawerLeftMenuMinimized' }),
        ...mapGetters('global/actionsource', ['getDataSourceType', 'isDataSourceNewRecord'] ),
        ...mapGetters('orders', {
            isCountersLoading: 'isCountersLoading',
            myOrdersOnExecutionCounter: 'getMyOrdersOnExecutionCounter',
            myOrdersOnExecutionUnreadedCounter: 'getMyOrdersOnExecutionUnreadedCounter',
            myOrdersOnCheckCounter: 'getMyOrdersOnCheckCounter',
            myOrdersOnCheckUnreadedCounter: 'getMyOrdersOnCheckUnreadedCounter',
            myProcessesOnAdjustmentCounter: 'getMyProcessesOnAdjustmentCounter',
            myProcessesOnAdjustmentUnreadedCounter: 'getMyProcessesOnAdjustmentUnreadedCounter',
            myProcessesExecutionControlCounter: 'getMyProcessesExecutionControlCounter',
            myProcessesExecutionControlUnreadedCounter: 'getMyProcessesExecutionControlUnreadedCounter',
            myControlUnreadedOrdersCounter: 'getMyControlUnreadedOrdersCounter',
            myControlOrdersCounter: 'getMyControlOrdersCounter',
            myControlUnreadedTasksCounter: 'getMyControlUnreadedTasksCounter',
            myControlTasksCounter: 'getMyControlTasksCounter',
            protocolCounter: 'getProtocolCounter',
            protocolUnreadCounter: 'getProtocolUnreadCounter',
            innerOrdersCounter: 'getInnerOrdersCounter',
            innerOrdersUnreadCounter: 'getInnerOrdersUnreadCounter',
            outerOrdersCounter: 'getOuterOrdersCounter',
            outerOrdersUnreadCounter: 'getOuterOrdersUnreadCounter',
            myProcessesOnProlongationCounter: 'getMyProcessesOnProlongationCounter',
            myProcessesOnProlongationUnreadCounter: 'getMyProcessesOnProlongationUnreadCounter'

        }),
        hasInWorkUread(){
            return this.myOrdersOnExecutionUnreadedCounter + this.myProcessesOnAdjustmentUnreadedCounter + this.myProcessesOnProlongationUnreadCounter + this.myProcessesExecutionControlUnreadedCounter > 0;
        },
        hasInMyControlUread(){
            return this.myControlUnreadedOrdersCounter + this.myControlUnreadedTasksCounter > 0;
        },
        hasInOrdersUnread() {
            return this.innerOrdersUnreadCounter + this.outerOrdersUnreadCounter > 0;
        },
        allowCreateProtocol() {
            let checker = (arr, target) => target.every(v => arr.includes(v));
            return checker(this.$store.getters['global/auth/getUserInfo'].Permissions, ["CreateProtocol", "CanSignChancellery"]);
        },
        allowSwetofor(){
            return this.$store.getters['global/auth/getUserInfo'].Permissions?.includes('ExecutionControl');
        },
        isDebug() {
            return true;// process?.env?.VUE_APP_DEBUG === "true";
        },
    },
    data: () => ({
        drawerLeftMenu: true,
        drawerLeftMenuHover: false,    
        myOrdersGroupActive: {
            active: true
        },
        myProcessesGroupActive: {
            active: false
        },
        myOrdersOnControlGroupActive: {
            active: false
        },
        svetoforGroupActive: {
            active: false
        },
        assignmentsGroupActive: {
            active: false
        }

    }),    
    methods: {
        ...mapActions('global/actionsource', ['loadDataSource']),
        LeftMenuMouseenter() {
            if (this.drawerLeftMenuMini)
                this.drawerLeftMenuHover = true;
        },
        LeftMenuMouseleave() {
            this.drawerLeftMenuHover = false;
        },
        async onCreateClicked() {
            let { params } = await this.$refs.CreateDlg.open();

            if (!params)
                return;

            await this.loadDataSource({ createType: params.createType, navigate: true, common: true });
        },
        async getOrderReport(type) {
            let response = await httpAPI({
                url: `api/orders/report?type=${type}`,
                method: 'POST',
                headers: { 'isCommon': true },
                data: { fromDate: '2023-01-01' }
            });

            alert(JSON.stringify(response?.data));
        },
        closeOtherGroups(groupName) {
            if (groupName === 'myOrdersGroupActive') {
                this.myProcessesGroupActive.active = this.myOrdersOnControlGroupActive.active = this.assignmentsGroupActive.active = this.svetoforGroupActive.active = false;
            } else if (groupName === 'myProcessesGroupActive') {
                this.myOrdersGroupActive.active = this.myOrdersOnControlGroupActive.active = this.assignmentsGroupActive.active = this.svetoforGroupActive.active = false;
            } else if (groupName === 'myOrdersOnControlGroupActive') {
                this.myOrdersGroupActive.active = this.myProcessesGroupActive.active = this.assignmentsGroupActive.active = this.svetoforGroupActive.active = false;
            } else if (groupName === 'assignmentsGroupActive'){
                this.myOrdersGroupActive.active = this.myProcessesGroupActive.active = this.myOrdersOnControlGroupActive.active = this.svetoforGroupActive.active = false;
            } else if (groupName === 'svetoforGroupActive'){
                this.myOrdersGroupActive.active = this.myProcessesGroupActive.active = this.myOrdersOnControlGroupActive.active = this.assignmentsGroupActive.active = false;
            }
        }
    }
}
</script>